var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconWineGlass = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF462D",
  d: "M12.68.838c.25 0 .465.184.512.44l.882 4.753c.313 1.35-.184 2.763-1.26 3.582l-2.294 1.722v6.745h2.084v1.087h-5.21V18.08H9.48v-6.746L7.183 9.608c-1.08-.827-1.575-2.253-1.252-3.61l.876-4.724a.53.53 0 0 1 .512-.44zM6.948 6.234c-.233.933.102 1.92.845 2.493l2.206 1.66 2.207-1.656c.737-.565 1.074-1.54.85-2.465l-.025-.136H6.968zm.221-1.19h5.66l-.578-3.12-4.503-.003z"
})));
export default SvgIconWineGlass;